import { cn } from '@repo/lib/cn';

import { useAudioVisualizer } from '@/hooks/voice-recorder/useAudioVisualizer';

import type { AudioVisualizerProps } from '.';

export function AudioVisualizer(audioVisualizerProps: AudioVisualizerProps) {
  const { className, isRecording, analyserNode, barCount = 25 } = audioVisualizerProps;

  const audioData = useAudioVisualizer({
    isRecording,
    analyserNode,
    barCount,
  });

  return (
    <div className={cn('flex items-center justify-center gap-1 px-4', className)}>
      {audioData.map((height, index) => (
        <div
          key={index}
          className="bg-muted-foreground/25 w-full max-w-2 min-w-[2px] rounded-full transition-all duration-75 ease-out"
          style={{
            height: `${Math.max(2, height)}%`,
            opacity: isRecording ? 1 : 0.3,
          }}
        />
      ))}
    </div>
  );
}
